import React, { useEffect, useState } from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from './Breadcrumb'
import { Icon } from '@iconify/react/dist/iconify.js'

import JobsTable from './JobTable'
import { Link } from 'react-router-dom'
import CompanyJobTable from './CompanyJobTable'
import MaintenanceTable from './MaintenanceTable'
import IssuesReportTable from './IssuesReportTable'
import { Card, CardBody } from 'react-bootstrap'
import { API_URL } from '..'

export default function IssuesReport() {
  const [jobsData , setJobData] = useState([])
  const [active , setActive] = useState(null)
  const [currentUser , setCurrentUser] = useState({})
  const [currentValues, setValues] = useState({
    new:0,
    accept: 0,
    total: 0,
    declined: 0,
    completed: 0,
  });


  const fetchJobsCompany = async ()=>{
    const user = JSON.parse(localStorage.getItem('user'));
    
    let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }
       let url= "";
       let jsonBody= JSON.stringify({
        "id": user.id
       });
    
        let response = await fetch(`${API_URL}/api/maintenance/issue/records/${user.id}`, { 
            method: "GET",
            headers: headersList
          });
          
          let data = await response.json();
        //   console.log(data)
        if(response.status === 200){
            setJobData(data)
            
       
        }
      
       
       
      
  }
useEffect(()=>{
    fetchJobsCompany()
},[1])
  return (
    <>
     <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Issue Reported" />

        {/* TableDataLayer */}
        
            <br></br>
      
        {
         jobsData.length !==0  ?      <IssuesReportTable jobsData={jobsData.reverse()}/>: null 
     

        }
    {
            jobsData.length === 0 ? 
            <Card className="mt-20">
                <CardBody>
                    <p className="text-center">No Maintenance Issue is reported yet.</p>
                </CardBody>
            </Card> :null
        }
        </MasterLayout>
    </>
  )
}
